// removed by extract-text-webpack-plugin
module.exports = {"shopAtContainer":"shopAtContainer__2i92P","shopAtHeading":"shopAtHeading__DwLU1","merchantsContainer":"merchantsContainer__1IgUb","lenderMerchantListDiv":"lenderMerchantListDiv__21SXL"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVB/merchants/style.css
// module id = VlkB
// module chunks = 446